/** Identifies the main-app tabs whose connection display follows the editing mode. */
export function isConnectionPlan(className: string | undefined): boolean {
  return className === "Room" || className === "Floor";
}

/** Keeps the manual switch independent of the editing mode outside main-app plans. */
export function isConnectionAnalyserAvailable(applicationMode: string, activeClassName: string | undefined, editMode: string, manuallyEnabled: boolean): boolean {
  if (editMode === "EloConcept") return false;
  if (applicationMode === "main" && !isConnectionPlan(activeClassName)) return manuallyEnabled;
  return editMode === "EloDetail" || editMode === "interactionConcept";
}

type ModeEndpoint = { className: string; isActorChannel?: boolean; isButtonChannel?: boolean; isScene?: boolean; isMultiplexer?: boolean };

/** Uses real endpoints, even when a collapsed navigator represents them by an ancestor. */
export function isConnectionEndpointVisibleInMode(endpoint: ModeEndpoint | undefined, mode: string | undefined): boolean {
  if (mode === "EloConcept") return false;
  if (!endpoint) return true;
  if (mode === "interactionConcept") {
    return !endpoint.isActorChannel
      && !["Actor", "Channel", "Terminal", "TerminalBlock", "TerminalStrip", "Fuse", "ELCB"].includes(endpoint.className);
  }
  return true;
}

export function isConnectionVisibleInMode(connection: { type: string; fromDevice?: ModeEndpoint; toDevice?: ModeEndpoint }, mode: string | undefined): boolean {
  if (mode === "EloConcept") return false;
  if (mode === "interactionConcept" && connection.type === "Channel") return false;
  return isConnectionEndpointVisibleInMode(connection.fromDevice, mode) && isConnectionEndpointVisibleInMode(connection.toDevice, mode);
}
